import { EmojiCollection, EmojiDefinition } from '../../ng-services/emoji-provider.service';

(function () {
    class EmojiPickerEmojisComponent {
        static $inject = ['$element', '$scope', '$timeout'];

        filterValue!: string;

        onEmojiSelected?: ({ $value }: { $value: EmojiDefinition }) => any;

        emojis!: EmojiCollection;
        emojisByCategory!: { [category: string]: EmojiCollection };
        frequentlyUsed!: EmojiCollection;

        private intersectionObserver?: IntersectionObserver;

        private visibleEntries: { [id: string]: boolean } = {};

        constructor(
            private $element: ng.IRootElementService,
            private $scope: ng.IScope,
            private $timeout: ng.ITimeoutService
        ) {}

        isVisible(id: string) {
            return this.visibleEntries[id];
        }

        $onInit() {
            this.$timeout(() => {
                this.intersectionObserver = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            const id = entry.target.getAttribute('data-id');
                            const isIntersecting = entry.isIntersecting;
                            this.visibleEntries[id as any] = isIntersecting || this.visibleEntries[id as any];
                        });

                        this.$scope.$digest();
                    },
                    {
                        root: this.$element.find('ty-emoji-picker-emojis')[0],
                        rootMargin: '0px',
                        threshold: 0.5,
                    }
                );

                document
                    .querySelectorAll('.emoji_picker_emojis__group')
                    .forEach((group) => this.intersectionObserver?.observe(group));
            });
        }

        $onDestroy() {
            this.intersectionObserver?.disconnect();
        }
    }

    angular.module('tradersyard').component('tyEmojiPickerEmojis', {
        template: `
        <div class="emoji_picker_emojis" id="emoji_scroll_target">
        <!-- frequently used -->
        <div ng-if="!$ctrl.filterValue && $ctrl.frequentlyUsed.length" class="emoji_picker_emojis__group">
            <h1>Frequently used</h1>
            <a href="#" ng-click="$ctrl.onEmojiSelected({$value: emoji})" class="emoji_picker_emojis__emoji" ng-repeat="emoji in $ctrl.frequentlyUsed"
            title="{{emoji.name}}">{{emoji.emoji}}</a>
        </div>
        <!-- grouped by category -->
        <div ng-if="!$ctrl.filterValue" data-id="{{name}}" class="emoji_picker_emojis__group" ng-repeat="(name, emojis) in $ctrl.emojisByCategory">
            <h1>{{name}}</h1>
            <div ng-if="$ctrl.isVisible(name)">
            <a href="#" ng-click="$ctrl.onEmojiSelected({$value: emoji}); $event.preventDefault()" class="emoji_picker_emojis__emoji" ng-repeat="emoji in emojis"
            title="{{emoji.name}}">{{emoji.emoji}}</a>
</div>
            <ty-loading-spinner ng-if="!$ctrl.isVisible(name)"/>
        </div>

        <!-- search results -->
        <div ng-if="$ctrl.filterValue" class="emoji_picker_emojis__group">
            <h1>Search results</h1>
            <a href="#" ng-click="$ctrl.onEmojiSelected({$value: emoji}); $event.preventDefault()"
            class="emoji_picker_emojis__emoji"
            ng-repeat="emoji in $ctrl.emojis |filter:{name: $ctrl.filterValue} as filteredEmojis"
            title="{{emoji.name}}"
            >{{emoji.emoji}}</a>

            <div ng-if="filteredEmojis.length == 0">No results found.</div>
        </div>
        </div>
`,
        controller: EmojiPickerEmojisComponent,
        bindings: {
            onEmojiSelected: '&',
            frequentlyUsed: '<',
            emojisByCategory: '<',
            emojis: '<',
            filterValue: '<',
        },
    });
})();
